import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Copy } from "lucide-react";
import { useCopyToClipboard } from "@/hooks/useCopyToClipboard";

interface EmailShareModalProps {
  email: string;
  open: boolean;
  onClose: () => void;
}

export function EmailShareModal({ email, open = true, onClose }: EmailShareModalProps) {
  const [copy] = useCopyToClipboard();
  return (
    <dialog className={`modal ${open ? "modal-open" : ""}`}>
      <div className="modal-box flex flex-col gap-4">
        <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2" onClick={onClose}>
          ✕
        </button>
        <h3 className="text-lg font-bold">Email address</h3>
        <p className="py-4">You can share your resume with them</p>
        <div className="flex items-center space-x-2">
          <div className="grid flex-1 gap-2">
            <Input id="link" defaultValue={email} readOnly />
          </div>
          <Button
            type="button"
            size="sm"
            className="bg-black px-3 hover:bg-black"
            onClick={() => copy({ text: email })}
          >
            <span className="sr-only">Copy</span>
            <Copy className="h-4 w-4" />
          </Button>
        </div>
        <div className="modal-action flex justify-start">
          <button className="btn btn-primary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </dialog>
  );
}
